export default class Folder {
    constructor(folder_id, image="", pos, coordinatex, coordinatey) {
        this.folder_id = folder_id;
        this.image = image;
        this.pos = pos;
        this.coordinatex = coordinatex;
        this.coordinatey = coordinatey;
    }
}